module.exports = __webpack_public_path__ + "img/juntas1.13ce10df.jpg";